import { render, staticRenderFns } from "./BatchesTable.vue?vue&type=template&id=501e5887"
import script from "./BatchesTable.vue?vue&type=script&lang=js"
export * from "./BatchesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports